import React, { FC } from 'react';
import GalanoGrotesqueText from '../GalanoGrotesqueText';
import Link from '../Link';
import View from '../View';
import styles from './styles';
import { LINK_TITLE, TEXT } from './constants';

export type AlreadyAMemberLinkProps = {
  navigation: any;
  textStyle?: any;
};

export const AlreadyAMemberLink: FC<AlreadyAMemberLinkProps> = (props) => {
  const { navigation, textStyle } = props;
  return (
    <View style={styles.container}>
      <GalanoGrotesqueText style={[styles.text, textStyle]}>
        {TEXT}
      </GalanoGrotesqueText>
      <Link
        onPress={() => navigation.navigate('SignIn')}
        text={LINK_TITLE}
        textStyle={styles.linkText}
      />
    </View>
  );
};

export default AlreadyAMemberLink;
